import { render, staticRenderFns } from "./PersonalDataFinancialSponsor.vue?vue&type=template&id=dae2447c&scoped=true&"
import script from "./PersonalDataFinancialSponsor.vue?vue&type=script&lang=ts&"
export * from "./PersonalDataFinancialSponsor.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalDataFinancialSponsor.vue?vue&type=style&index=0&id=dae2447c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae2447c",
  null
  
)

export default component.exports